import { Routes } from "@angular/router";

export const LOAN_ROUTES: Routes = [
  {
    path: "list",
    loadComponent: () =>
      import("./pages/loan-list/loan-list.component").then(
        (m) => m.LoanListComponent,
      ),
    title: "Loans - Foresight",
    data: {
      breadcrumb: "Overview",
      breadcrumbModule: "Loans",
      breadcrumbTrail: [{ label: "Overview", reload: true }],
      pageId: "loans-overview",
    },
  },
  {
    path: "view/:id",
    loadComponent: () =>
      import("./pages/view-loan/view-loan.component").then(
        (m) => m.ViewLoanComponent,
      ),
    title: "Loan Details - Foresight",
    data: {
      breadcrumb: "Loan Details",
      breadcrumbModule: "Loans",
      breadcrumbTrail: [
        { label: "Overview", route: "/loan/list" },
        { type: "detail", param: "id", prefix: "Loan " },
      ],
      pageId: "loan-details",
    },
  },
  { path: "", redirectTo: "list", pathMatch: "full" },
];
